const styles = () => ({
	'@media (min-width: 1024px)': {
		languageSelect: {
			alignSelf: 'flex-end',
			width: '256px'
		}
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/pages/main/collections/styles.js